<template>
    <div class="goods_components">
        <router-link :to="{name:'exchangedetail',params:{'goodsid':goods.id}}" v-for="(goods,index) in goodsList" :key="index" class="goods">
            <img :src="goods['imgurl'][0]"/>
            <span class="van-multi-ellipsis--l2 goodsname">{{goods.name}}</span>
            <div class="tag van-ellipsis">
                <Tag type="warning" v-for="(tag,key) in goods.tags" :key="key">{{tag}}</Tag>
            </div>
            <div class="points van-ellipsis">
                <div>
                    <span>
                    <img :src="require('assets/img/common/coin.png')" class="coin" alt="">
                    {{goods.sellingpoints}}
                    </span>
                    <template v-if="goods.sellingprice*1>0">
                        <span>+ </span><span>¥</span>{{goods.sellingprice}}
                    </template>
                </div>
                <del v-if="goods.originalprice">
                    ¥ {{goods.originalprice}}
                </del>
            </div>
            <div class="foot">
                <div class="mvbutton btn">
                    立即兑换
                </div>
            </div>
        </router-link>
    </div>
</template>
<script>
    import './index.less'
    import {Tag} from 'vant';

    export default {
        name: "goodsList",
        components: {
            Tag
        },
        props: {
            goodsList: Array
        }
    }
</script>
